const get = store => (store.salesComm ? store.salesComm : {});
export const getSalesReps = store => get(store).salesReps;
export const getCustomers = store => get(store).customers;
export const getRates = store => get(store).rates;
export const getReport = store => get(store).report;
export const getCommission = store => get(store).commission;
export const isLoaded = store => get(store).isLoaded;
